import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
// Formik
import { useFormikContext } from 'formik';
// Elements
import Label from '../elements/Label';
import Error from '../elements/Error';
const FileUploadField = ({ formik = {}, hasError = false, fieldId, data }) => {
  var _a;
  const { handleChange, values } = useFormikContext();
  const inputRef = React.useRef(null);
  let accept = '';
  if (data.allowedExtensions) {
    const extensions = typeof data.allowedExtensions === 'string' ? data.allowedExtensions.split(',') : data.allowedExtensions;
    extensions.forEach((extension) => {
      accept += accept !== '' ? `, .${extension.trim()}` : `.${extension.trim()}`;
    });
  }
  // Conditional logic
  if (data.conditionalLogic) {
    // Whether or not to show the field
    if (data.conditionalLogic.actionType === 'SHOW') {
      let show = true;
      data.conditionalLogic.rules.forEach((rule) => {
        if (rule.operator === 'IS') {
          if (values[`input_${rule.fieldId}`].name !== rule.value) {
            show = false;
          }
        }
        if (rule.operator === 'IS_NOT') {
          if (values[`input_${rule.fieldId}`].name === rule.value) {
            show = false;
          }
        }
      });
      if (!show) {
        return null;
      }
    }
  }
  return _jsxs("div", { className: `form-duuf-group form-duuf-group-${data.type.toLowerCase()}${data.cssClass ? ` ${data.cssClass}` : ''} position-relative`, children: [_jsx(Label, { fieldId: fieldId, data: data }), _jsx(Error, { fieldId: fieldId, data: data, hasError: hasError, formik: formik }), _jsxs("div", { className: "form-duuf-file d-flex align-items-center flex items-center", children: [_jsx("input", { multiple: data.canAcceptMultipleFiles || false, type: "file", onChange: (event) => {
          const { target: { files } } = event;
          if (!files) {
            return;
          }
          if (files.length > 1) {
            handleChange({
              target: {
                name: fieldId,
                value: Array.from(files)
              }
            });
          } else
          {
            for (let i = 0; i < files.length; i += 1) {
              handleChange({
                target: {
                  name: fieldId,
                  value: files[i]
                }
              });
            }
          }
        }, id: fieldId, name: fieldId, ref: inputRef, accept: accept, className: "form-duuf-file-input d-none" }, fieldId), _jsx("span", { className: "form-duuf-file-button", children: _jsx("button", { type: "button", onClick: () => {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
          }, children: data.description }) }), values[fieldId] && _jsx("div", { className: "form-duuf-file-name", children: (_a = values[fieldId]) === null || _a === void 0 ? void 0 : _a.name })] })] });
};
export default FileUploadField;